import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const RESIZE_OBSERVER_MSG = 'ResizeObserver loop completed with undelivered notifications.';

function isResizeObserverError(message) {
  return typeof message === 'string' && message.includes(RESIZE_OBSERVER_MSG);
}

window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.message)) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const message =
    event?.reason?.message ||
    event?.reason ||
    '';

  if (isResizeObserverError(message)) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
  }
});

const NativeResizeObserver = window.ResizeObserver;

if (NativeResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);